import publicPageSeo from "@/lib/public-page-seo.json";

export interface PageSeo {
  canonicalPath: string;
  description: string;
  indexable: boolean;
  title: string;
}

export const DEFAULT_DESCRIPTION = publicPageSeo["/"].description;

const INDEXABLE_PAGES: Record<string, Omit<PageSeo, "canonicalPath" | "indexable">> = publicPageSeo;

const NON_INDEXABLE_TITLES: Record<string, string> = {
  "/account": "Account | Carmen",
  "/admin": "Beheer | Carmen",
  "/download": "Download | Carmen",
  "/login": "Inloggen | Carmen",
  "/login/email": "Inloggen | Carmen",
  "/passkey-handoff": "Aanmelden | Carmen",
  "/recover": "Account herstellen | Carmen",
  "/recover/reset": "Wachtwoord herstellen | Carmen",
  "/richtlijnen": "Richtlijnen | Carmen",
  "/signup": "Registreren | Carmen",
  "/verified": "E-mailadres bevestigd | Carmen",
  "/widget-email-login": "Inloggen in de widget | Carmen",
  "/widget-passkey-login": "Aanmelden | Carmen",
};

export function normalizeSeoPath(pathname: string): string {
  if (pathname === "/") return pathname;
  return pathname.replace(/\/+$/, "") || "/";
}

export function resolvePageSeo(pathname: string): PageSeo {
  const canonicalPath = normalizeSeoPath(pathname);
  const publicPage = INDEXABLE_PAGES[canonicalPath];

  if (publicPage) {
    return {
      ...publicPage,
      canonicalPath,
      indexable: true,
    };
  }

  return {
    canonicalPath,
    description: "Deze Carmen-pagina is niet bestemd voor opname in zoekresultaten.",
    indexable: false,
    title: NON_INDEXABLE_TITLES[canonicalPath] ?? "Pagina niet gevonden | Carmen",
  };
}
